import { AnyAction } from "redux";
import {
  fetchKitchenFailed,
  fetchKitchenStart,
  fetchKitchenSuccess,
  setOnlineOrdersConfigs,
} from "./kitchen.action";
import { Kitchen, OnlineOrdersConfigs } from "./kitchen.types";

export type KitchenState = {
  readonly kitchen: Kitchen;
  readonly kitchenSlug: string;
  readonly isLoading: boolean;
  readonly error: Error | null;
  readonly onlineOrdersConfigs: OnlineOrdersConfigs;
};
export const KITCHEN_INITIAL_STATE: KitchenState = {
  kitchen: {} as Kitchen,
  kitchenSlug: "",
  isLoading: false,
  error: null,
  onlineOrdersConfigs: null,
};

export const categoriesReducer = (
  state = KITCHEN_INITIAL_STATE,
  action: AnyAction
): KitchenState => {
  if (fetchKitchenStart.match(action)) {
    return { ...state, isLoading: true, error: null };
  }

  if (fetchKitchenSuccess.match(action)) {
    return {
      ...state,
      kitchen: action.payload,
      isLoading: false,
      error: null,
    };
  }

  if (fetchKitchenFailed.match(action)) {
    return {
      ...state,
      error: action.payload,
      isLoading: false,
      kitchen: {} as Kitchen,
      onlineOrdersConfigs: null,
    };
  }

  if (setOnlineOrdersConfigs.match(action)) {
    return {
      ...state,
      onlineOrdersConfigs: action.payload,
    };
  }

  return state;
};
